import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'AdminPage.header',
    defaultMessage: 'Admin Panel',
  },
  usersManager: {
    id: 'AdminPage.usersManager',
    defaultMessage: 'Users',
  },
  introMessages: {
    id: 'AdminPage.introMessages',
    defaultMessage: 'Intro Messages',
  },
  createNewMessage: {
    id: 'AdminPage.createNewMessage',
    defaultMessage: ' Create New Intro Message',
  },
  audioFileName: {
    id: 'AdminPage.audioFileName',
    defaultMessage: 'Intro Message File Name',
  },
  create: {
    id: 'AdminPage.create',
    defaultMessage: 'Create',
  },
});



// WEBPACK FOOTER //
// ./components/pages/AdminPage/messages.js